var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcUtilityBill = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M27.986 12H4.013c-.747 0-1.347.6-1.347 1.347v13.306c0 .747.6 1.347 1.347 1.347h23.973c.747 0 1.347-.6 1.347-1.347V13.347c0-.747-.6-1.347-1.347-1.347Z",
  fill: "#A3D3FF"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m27.333 17.333-11.334 5.334-11.333-5.334v-12C4.666 4.6 5.266 4 5.999 4h20c.734 0 1.334.6 1.334 1.333v12Z",
  fill: "#2D91FF"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M16 8.134c.286 0 .541.183.632.455l2.034 6.102L20.7 8.589a.667.667 0 0 1 1.265.422l-.79 2.373h1.491a.667.667 0 1 1 0 1.333H20.73l-1.431 4.294a.667.667 0 0 1-1.266 0L16 10.91l-2.034 6.101a.668.668 0 0 1-1.265 0l-1.431-4.294H9.333a.667.667 0 0 1 0-1.333h1.49l-.79-2.373A.668.668 0 0 1 11.3 8.59l2.034 6.102 2.034-6.102.041-.097A.667.667 0 0 1 16 8.134Z",
  fill: "#fff"
})));
export default SvgIcUtilityBill;